import declare from "dojo/_base/declare";
import _AttributeDeleteMixin from "src/SiteAdmin/Attributes/_AttributeDeleteMixin";

const PPAttributeDeleteController = declare(_AttributeDeleteMixin, {

});

export = PPAttributeDeleteController;